import { css } from 'styled-components';
import { color } from '@design/templateFns';

// Define your base styles with css helper
const buttonBaseStyles = css`
  width: 36px;
  height: 36px;
  border: 2px solid ${color('gray2')};
  transition:
    color 0.2s ease-in-out,
    background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
  border-radius: 50%;
  box-sizing: border-box;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  padding: 0;
  text-decoration: none;

  &:visited {
    background-color: transparent;
    color: ${color('fg')};
    border-color: ${color('gray2')};
  }
  &.swiper-button-lock {
    display: none;
  }
`;

export const button = css`
  ${buttonBaseStyles}
  color: ${color('fg')};
  &:not(:disabled):hover {
    background-color: ${color('gray1')};
    color: ${color('gray5')};
    border-color: ${color('gray2')};
  }
  &:not(:disabled):active {
    background-color: ${color('gray1')};
    color: ${color('fg')};
    border-color: ${color('gray4')};
  }
  &:focus {
    background-color: transparent;
    color: ${color('fg')};
    border-color: ${color('gray3')};
  }
  &:disabled {
    cursor: default;
    color: ${color('gray3')};
  }
`;

// Define specific variant styles
export const light = css`
  ${button};
`;

export const dark = css`
  ${button};
  background-color: ${color('fg')};
  border-color: ${color('fg')};
  color: ${color('bg')};

  &:not(:disabled):hover {
    background-color: ${color('gray5')};
    border-color: ${color('gray5')};
    color: ${color('bg')};
  }
  &:not(:disabled):active {
    background-color: ${color('gray4')};
    color: ${color('bg')};
    border-color: ${color('gray4')};
  }
  &:focus {
    background-color: ${color('fg')};
    border-color: ${color('fg')};
  }
  &:disabled {
    cursor: default;
    background-color: ${color('fg')};
    color: ${color('gray3')};
  }
`;
